// src/helpers.ts
async function addCookieConsentCss() {
  return new Promise((resolve, reject) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.onload = () => resolve();
    link.onerror = () => reject();
    link.href = "https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@3.0.1/dist/cookieconsent.css";
    document.getElementsByTagName("head")[0].appendChild(link);
  });
}
async function addCookieConsentJs() {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject();
    script.src = "https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@3.0.1/dist/cookieconsent.umd.js";
    document.body.appendChild(script);
  });
}
function addButton(translations) {
  const ariaLabel = translations?.cookieButton?.ariaLabel ?? "Show Cookie Preferences";
  const button = document.createElement("button");
  button.id = "cookieConsentButton";
  button.type = "button";
  button.setAttribute("data-cc", "show-preferencesModal");
  button.setAttribute("aria-label", ariaLabel);
  button.innerHTML = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="100%" height="100%" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.25 12C1.25 6.06129 6.07503 1.25 12.0233 1.25C12.8479 1.25 13.6518 1.34258 14.4247 1.5182C14.6368 1.5664 14.8176
        1.70433 14.92 1.89621C15.0225 2.08809 15.0367 2.31502 14.9588 2.51813C14.8422 2.82209 14.778 3.1527 14.778 3.5C14.778
        4.49492 15.3075 5.36792 16.1056 5.85182C16.3103 5.97594 16.4435 6.19031 16.464 6.42882C16.4846 6.66732 16.39 6.9013
        16.2095 7.05858C15.9451 7.28905 15.7803 7.6251 15.7803 8C15.7803 8.68871 16.3404 9.25 17.035 9.25C17.267 9.25 17.4821
        9.18795 17.667 9.08019C17.8915 8.94934 18.1678 8.94405 18.3972 9.06621C18.6266 9.18837 18.7764 9.42056 18.7931
        9.6799C18.8855 11.113 20.0814 12.25 21.5455 12.25C21.6673 12.25 21.787 12.2422 21.904 12.2271C22.1304 12.1978 22.3578
        12.2733 22.5218 12.4321C22.6857 12.5909 22.7685 12.8158 22.7465 13.043C22.2203 18.4924 17.6193 22.75 12.0233
        22.75C6.07503 22.75 1.25 17.9387 1.25 12ZM10 12C10 11.4477 10.4477 11 11 11H11.009C11.5613 11 12.009 11.4477 12.009
        12C12.009 12.5523 11.5613 13 11.009 13H11C10.4477 13 10 12.5523 10 12ZM6 9C5.44772 9 5 9.44771 5 10C5 10.5523 5.44772 11
        6 11H6.00898C6.56127 11 7.00898 10.5523 7.00898 10C7.00898 9.44772 6.56127 9 6.00898 9H6ZM11 18C11 17.4477 11.4477 17 12
        17H12.009C12.5613 17 13.009 17.4477 13.009 18C13.009 18.5523 12.5613 19 12.009 19H12C11.4477 19 11 18.5523 11 18ZM10.5303
        6.53033C10.8232 6.23744 10.8232 5.76256 10.5303 5.46967C10.2374 5.17678 9.76256 5.17678 9.46967 5.46967L8.46967
        6.46967C8.17678 6.76256 8.17678 7.23744 8.46967 7.53033C8.76256 7.82322 9.23744 7.82322 9.53033 7.53033L10.5303
        6.53033ZM17.0303 13.9697C17.3232 14.2626 17.3232 14.7374 17.0303 15.0303L16.0303 16.0303C15.7374 16.3232 15.2626 16.3232
        14.9697 16.0303C14.6768 15.7374 14.6768 15.2626 14.9697 14.9697L15.9697 13.9697C16.2626 13.6768 16.7374 13.6768 17.0303
        13.9697ZM6.46967 15.5303C6.17678 15.2374 6.17678 14.7626 6.46967 14.4697C6.76256 14.1768 7.23744 14.1768 7.53033
        14.4697L8.53033 15.4697C8.82322 15.7626 8.82322 16.2374 8.53033 16.5303C8.23744 16.8232 7.76256 16.8232 7.46967
        16.5303L6.46967 15.5303Z"
      fill="currentColor"/>
  </svg>
  `;
  document.body.appendChild(button);
  return button;
}
function addCustomCss() {
  const style = document.createElement("style");
  style.innerHTML = `
  #cc-main {
    --cc-primary-color: var(--cc-text);
    --cc-secondary-color: var(--cc-text);
    --cc-btn-primary-bg: var(--cc-secondary);
    --cc-btn-primary-border-color: var(--cc-secondary);
    --cc-toggle-on-bg: var(--cc-primary);
  }

  #cookieConsentButton {
    --size: 50px;
    position: fixed;
    right: 0;
    bottom: 30px;
    z-index: 1000;
    background-color: var(--cc-primary);
    border-radius: 25px 0 0 25px;
    color: white;
    border: none;
    padding: 5px;
    width: var(--size);
    height: var(--size);
    cursor: pointer;
    transition: transform 300ms;
    opacity: 0;
    pointer-events: none;
    transform-origin: right center;
  }

  #cookieConsentButton.show {
    opacity: 1;
    pointer-events: all;
  }

  #cookieConsentButton:hover {
    transform: scale(1.1);
  }

  @media (max-width: 700px) {
    #cookieConsentButton {
      --size: 30px;
    }
  }

  `;
  document.getElementsByTagName("head")[0].appendChild(style);
}
async function addGoogleTagManagerScript(gtagId) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
    script.onload = () => resolve();
    script.onerror = () => reject();
    document.head.appendChild(script);
  });
}

// src/analytics.js
var clarity = {
  enable(id) {
    ;
    (function(c, l, a, r, i, t, y) {
      c[a] = c[a] || function() {
        ;
        (c[a].q = c[a].q || []).push(arguments);
      };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", id);
    window.clarity("consent");
  },
  disable() {
    window.clarity("consent", false);
    window.location.reload();
  }
};
var gAnalytics = {
  init() {
    window.dataLayer = window.dataLayer || [];
    gtag("consent", "default", {
      analytics_storage: "denied",
      functionality_storage: "denied",
      personalization_storage: "denied",
      security_storage: "denied"
    });
  },
  enable(id) {
    gtag("js", /* @__PURE__ */ new Date());
    gtag("config", id);
    gtag("consent", "update", {
      analytics_storage: "granted",
      functionality_storage: "granted",
      personalization_storage: "granted",
      security_storage: "granted"
    });
  },
  disable() {
    gtag("consent", "update", {
      analytics_storage: "denied",
      functionality_storage: "denied",
      personalization_storage: "denied",
      security_storage: "denied"
    });
  }
};
function gtag() {
  window.dataLayer.push(arguments);
}

// src/main.ts
async function showCookieBanner(config) {
  const promises = [addCustomCss(), addCookieConsentCss(), addCookieConsentJs()];
  if (config.gtagEnabled && config.gtag?.id) {
    promises.push(addGoogleTagManagerScript(config.gtag?.id));
  }
  const translations = config.translations;
  addCustomCss();
  const cookieConsentButton = addButton(translations);
  await Promise.all(promises);
  if (config.gtagEnabled) gAnalytics.init();
  const hasAnalytics = config.clarityEnabled || config.gtagEnabled;
  window.CookieConsent.run({
    onConsent: () => cookieConsentButton.classList.add("show"),
    categories: {
      necessary: {
        enabled: true,
        // this category is enabled by default
        readOnly: true
        // this category cannot be disabled
      },
      analytics: {
        services: {
          ga: {
            label: "Google Analytics",
            onAccept: () => {
              if (config.gtagEnabled && config.gtag?.id)
                gAnalytics.enable(config.gtag.id);
            },
            onReject: () => {
              if (config.gtagEnabled) {
                gAnalytics.disable();
              }
            },
            cookies: [
              {
                name: /^_ga/
                // regex: match all cookies starting with '_ga'
              },
              {
                name: "_gid"
                // string: exact cookie name
              }
            ]
          },
          clarity: {
            label: "Microsoft Clarity",
            onAccept: () => {
              if (config.clarityEnabled && config.clarity?.id)
                clarity.enable(config.clarity.id);
            },
            onReject: () => {
              if (config.clarityEnabled && config.clarity?.id) clarity.disable();
            },
            cookies: [
              {
                name: /^(_clck|_clsk|ANONCHK|CLID|MR|SM|MUID)/
              }
            ]
          }
        }
      }
    },
    language: {
      default: "en",
      translations: {
        en: {
          consentModal: {
            title: translations.consentModal.title,
            description: translations.consentModal.description,
            acceptAllBtn: translations.consentModal.acceptAllBtn,
            acceptNecessaryBtn: translations.consentModal.acceptNecessaryBtn,
            showPreferencesBtn: translations.consentModal.showPreferencesBtn,
            footer: `
                        <a href="${translations.consentModal.imprint_url}" target="_blank">${translations.consentModal.imprint}</a>
                        <a href="${translations.consentModal.privacy_url}" target="_blank">${translations.consentModal.privacy}</a>
                    `
          },
          preferencesModal: {
            title: translations.preferencesModal.title,
            acceptAllBtn: translations.preferencesModal.acceptAllBtn,
            acceptNecessaryBtn: translations.preferencesModal.acceptNecessaryBtn,
            savePreferencesBtn: translations.preferencesModal.savePreferencesBtn,
            closeIconLabel: translations.preferencesModal.closeIconLabel,
            sections: [
              {
                title: translations.preferencesModal.info.title,
                description: translations.preferencesModal.info.description
              },
              {
                title: translations.preferencesModal.necessary.title,
                description: translations.preferencesModal.necessary.description,
                linkedCategory: "necessary"
              },
              ...hasAnalytics ? [
                {
                  title: translations.preferencesModal.analytics?.title,
                  description: translations.preferencesModal.analytics?.description,
                  linkedCategory: "analytics"
                }
              ] : [],
              {
                title: translations.preferencesModal.more.title,
                description: translations.preferencesModal.more.description
              }
            ]
          }
        }
      }
    }
  });
}
export {
  showCookieBanner
};
//# sourceMappingURL=index.js.map